import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { COLLECTIONS } from '../data/mock';
import { useCatalog } from '../context/CatalogContext';
import { useTranslation } from '../hooks/useTranslation';
import ProductCard from '../components/ProductCard';

export default function CollectionDetail() {
  const { slug } = useParams();
  const { products, loading } = useCatalog();
  const { t } = useTranslation();
  const col = COLLECTIONS.find((c) => c.slug === slug);
  const items = products.filter((p) => p.collection === slug);

  if (!col) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-center">
        <div>
          <div className="font-serif text-3xl">{t('collectionDetail.notFound')}</div>
          <Link to="/collections" className="text-gold text-xs tracking-luxury uppercase mt-6 inline-block">{t('collectionDetail.back')}</Link>
        </div>
      </div>
    );
  }

  return (
    <main>
      {/* Sober header - no image, no tagline — shifted slightly higher for visual balance */}
      <section className="pt-14 pb-8 lg:pt-20 lg:pb-10 bg-ivory text-center">
        <div className="max-w-3xl mx-auto px-4 animate-fade-up">
          <div className="text-[11px] tracking-luxury uppercase text-gold mb-4">{t('collectionDetail.label')}</div>
          <h1 className="font-serif text-5xl md:text-6xl font-light" data-testid="collection-detail-title">{col.name}</h1>
        </div>
      </section>

      {/* Back */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <Link to="/collections" className="inline-flex items-center gap-2 text-[11px] tracking-luxury uppercase text-[#666] hover:text-gold" data-testid="collection-detail-back-link">
          <ArrowLeft className="w-4 h-4" /> {t('collectionDetail.back')}
        </Link>
      </div>

      {/* Products */}
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-0 sm:px-4 lg:px-8">
          {loading ? (
            <div className="text-center py-20 text-[#666]">{t('collectionDetail.loading')}</div>
          ) : items.length === 0 ? (
            <div className="text-center py-20">
              <div className="font-serif text-3xl">{t('collectionDetail.emptyTitle')}</div>
              <p className="text-[#666] mt-4">{t('collectionDetail.emptyText')}</p>
              <Link to="/montres" className="inline-flex mt-8 px-8 py-3 bg-[#1A1A1A] text-white text-[11px] tracking-luxury uppercase hover:bg-gold transition-colors">
                {t('collectionDetail.viewAll')}
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 sm:gap-6 md:gap-10 lg:gap-14">
              {items.map((p) => <ProductCard key={p.slug} product={p} />)}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
